import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { SITE_URL } from "../../data/site"
import { JsonLd } from "./JsonLd"

type SeoProps = {
  title: string
  description?: string
  canonicalPath?: string
  ogImage?: string
  jsonLd?: object | object[]
  noindex?: boolean
}

export const SEO = ({
  title,
  description,
  canonicalPath,
  ogImage,
  jsonLd,
  noindex,
}: SeoProps) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title
  const fullTitle = defaultTitle ? `${title} | ${defaultTitle}` : title
  const canonical = canonicalPath ? `${SITE_URL}${canonicalPath}` : SITE_URL

  return (
    <>
      <Helmet
        htmlAttributes={{ lang: "pt-BR" }}
        title={title}
        titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : undefined}
      >
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonical} />
        {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonical} />
        {ogImage ? <meta property="og:image" content={ogImage} /> : null}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:creator"
          content={site.siteMetadata?.author || ""}
        />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={metaDescription} />
      </Helmet>
      {jsonLd ? <JsonLd data={jsonLd} /> : null}
    </>
  )
}
